export const linkedTooltip =
  'São consideradas Pessoas Vinculadas em oferta pública, conforme instrução CVM 400 art. 50, os controladores ou administradores das Instituições Intermediárias e da emissora ou outras pessoas vinculadas(todos os colaboradores da Genial Investimentos) à emissão e distribuição, bem como seus cônjuges ou companheiros, seus ascendentes(Pais e Avós), descendentes(Filhos e Netos) e colaterais(Irmãos) até o 2º grau.';

export const investorTypeOptions = [
  { label: 'Investidor não vinculado', value: 'unlinked' },
  { label: 'Investidor vinculado', value: 'linked' },
] as const;

export type InvestorType = (typeof investorTypeOptions)[number]['value'];

export const getInvestorTypeOptions = (
  isLoading: boolean,
  hasLinked?: boolean,
  hasUnlinked?: boolean
) => {
  const investorOptions = investorTypeOptions.map((option) => {
    if (isLoading) {
      return { ...option, disabled: true };
    }
    if (option.value === 'linked' && hasLinked) {
      return { ...option, disabled: false };
    } else if (option.value === 'unlinked' && hasUnlinked) {
      return { ...option, disabled: false };
    } else {
      return { ...option, disabled: true };
    }
  });
  return investorOptions;
};
